import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, MapPin, Star, Users } from 'lucide-react';
import { Button } from './ui/button';

const SupplierCard = ({ supplier }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-md p-4 hover:shadow-md transition-shadow relative">
      {supplier.plan_name && (
        <span
          className="absolute top-2 right-2 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide"
          style={{ backgroundColor: `${supplier.plan_color || '#9ca3af'}22`, color: supplier.plan_color || '#374151' }}
        >
          {supplier.plan_name}
        </span>
      )}
      <div className="flex items-start gap-3">
        {supplier.logo_url ? (
          <img src={supplier.logo_url} alt={supplier.name} className="w-14 h-14 rounded-md object-cover bg-gray-100 shrink-0 border border-gray-200" />
        ) : (
          <div className="w-14 h-14 rounded-md bg-gradient-to-br from-[#2c54b2] to-[#1e3a8a] text-white flex items-center justify-center font-bold text-lg shrink-0">
            {supplier.logo}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <Link to={`/vendor/${supplier.slug || supplier.id}`} className="font-semibold text-gray-900 hover:text-[#2c54b2] transition-colors block truncate">
            {supplier.name}
          </Link>
          <div className="flex items-center gap-1 text-xs text-gray-600 mt-0.5">
            <MapPin className="w-3 h-3" /> {supplier.city}
          </div>
          <div className="flex items-center gap-1 mt-1">
            <ShieldCheck className="w-3.5 h-3.5 text-green-600" />
            <span className="text-xs font-medium text-green-700">{supplier.gst}</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 mt-3 pt-3 border-t border-gray-100 text-xs">
        <div>
          <div className="flex items-center gap-0.5 text-amber-500">
            <Star className="w-3 h-3 fill-amber-500" />
            <span className="font-semibold text-gray-900">{supplier.rating}</span>
          </div>
          <div className="text-gray-500 mt-0.5">Rating</div>
        </div>
        <div>
          <div className="font-semibold text-gray-900">{supplier.response}</div>
          <div className="text-gray-500 mt-0.5">Response</div>
        </div>
        <div>
          <div className="font-semibold text-gray-900">{supplier.established}</div>
          <div className="text-gray-500 mt-0.5">Since</div>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-1">
        {supplier.categories.slice(0, 3).map((c) => (
          <span key={c} className="text-xs px-2 py-0.5 bg-blue-50 text-[#2c54b2] rounded">{c}</span>
        ))}
      </div>
      <Link to={`/vendor/${supplier.slug || supplier.id}`}>
        <Button variant="outline" className="w-full mt-3 h-8 text-xs border-[#ee5e23] text-[#ee5e23] hover:bg-[#ee5e23] hover:text-white">View Profile</Button>
      </Link>
    </div>
  );
};

export default SupplierCard;
